import { createStorefrontApiClient } from "@shopify/storefront-api-client";

import { env } from "@/env";

export const storefrontApi = createStorefrontApiClient({
  storeDomain: env.VITE_SHOPIFY_DOMAIN,
  apiVersion: env.VITE_SHOPIFY_API_VERSION,
  publicAccessToken: env.VITE_SHOPIFY_ACCESS_TOKEN,
});
